import axios from 'axios';
import type {
  CheckoutSessionResponse,
  Subscription,
  CancelSubscriptionResponse,
  SubscriptionsHistory,
  PlansResponse,
  CheckoutSessionPayload,
  CreateSessionPayload,
  CreateSessionResponse,
} from './billing.service.types';

const backendUrl = import.meta.env.VITE_API_BILLING_URL;

const commonHeaders = {
  'Content-Type': 'application/json',
};
const billingApi = axios.create({
  baseURL: backendUrl,
  withCredentials: true,
  headers: { ...commonHeaders },
});

export interface CustomerPortalResponse {
  url: string;
}

export const billingService = {
  // Suscripciones
  createCustomerPortal(returnUrl: string) {
    return billingApi.post<CustomerPortalResponse>(
      '/subscriptions/customer-portal',
      { returnUrl },
    );
  },
  createCheckoutSession(payload?: CheckoutSessionPayload) {
    return billingApi.post<CheckoutSessionResponse>(
      '/subscriptions/create-session',
      payload,
    );
  },
  // Pagos (Tickets de Eventos)
  createPaymentSession(payload: CreateSessionPayload) {
    return billingApi.post<CreateSessionResponse>(
      '/payments/create-session',
      payload,
    );
  },
  getCurrentSubscription() {
    return billingApi.get<Subscription>('/subscriptions/current');
  },
  cancelSubscription() {
    return billingApi.post<CancelSubscriptionResponse>(
      '/subscriptions/cancel',
      undefined,
    );
  },
  reactivateSubscription() {
    return billingApi.post('/subscriptions/reactivate');
  },
  upgradeSubscription(planSlug: string, interval: 'month' | 'year') {
    return billingApi.post('/subscriptions/upgrade', { planSlug, interval });
  },
  downgradeSubscription(planSlug: string, interval: 'month' | 'year') {
    return billingApi.post('/subscriptions/downgrade', { planSlug, interval });
  },
  getSubscriptionsHistory() {
    return billingApi.get<SubscriptionsHistory>('/subscriptions/history');
  },
  getPlans() {
    return billingApi.get<PlansResponse>('/plans');
  },
};
